import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { sosReleaseDetailsCalendarListApi } from '@/services/releaseServices';

const initialFilters = {
  releaseName: '',
  jiraProjectIds: [],
  createdByIds: [],
  applicationIds: [],
  releaseStatusCodes: [1, 2],
  releaseDatesCodes: [1, 2],
  archiveStatusCodes: [1],
  complianceStatus: [],
  monthAndYear: {
    month: dayjs().month() + 1,
    year: dayjs().year(),
  },
};

export const fetchFilteredCalendarReleases = createAsyncThunk(
  'releaseCalendar/fetchReleases',
  async (filters, { dispatch }) => {
    const body = { ...filters };
    delete body.complianceStatus;
    delete body.monthAndYear;
    try {
      const response = await sosReleaseDetailsCalendarListApi(
        body,
        filters.monthAndYear.month,
        filters.monthAndYear.year,
      );
      dispatch(resetReleasesCalendars());
      dispatch(addReleasesCalendars(response.releaseManagementCardData || {}));
    } catch (error) {
      console.error('Failed to load filtered calendar releases:', error);
      throw error;
    }
  },
);

const releaseCalendarSlice = createSlice({
  name: 'releaseCalendar',
  initialState: { eventsByDate: {}, filters: initialFilters },
  reducers: {
    addReleasesCalendars: (state, { payload }) => {
      Object.entries(payload).forEach(([key, value]) => {
        state.eventsByDate[key] = [
          ...(state.eventsByDate[key] || []),
          ...value,
        ];
      });
    },
    resetReleasesCalendars: (state) => {
      state.eventsByDate = {};
    },
    addReleaseFilters: (state, { payload: { key, value } }) => {
      state.filters[key] = value;
    },
    clearReleaseFilters: (state, { payload }) => {
      state.filters = {
        ...state.filters,
        ...payload,
        monthAndYear: state.filters.monthAndYear,
      };
    },
    updateMonthAndYear: (state, { payload }) => {
      state.filters.monthAndYear = payload;
    },
  },
});

export const {
  addReleasesCalendars,
  resetReleasesCalendars,
  addReleaseFilters,
  clearReleaseFilters,
  updateMonthAndYear,
} = releaseCalendarSlice.actions;

export const releaseCalendarFilterMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    const result = next(action);
    if (
      (addReleaseFilters.match(action) &&
        action.payload.key !== 'complianceStatus') ||
      clearReleaseFilters.match(action)
    ) {
      return dispatch(
        fetchFilteredCalendarReleases(getState().releaseCalendar.filters),
      );
    }
    return result;
  };

export default releaseCalendarSlice.reducer;
